import { Realty, services } from '@ambita/ambita-components-core';

const util = services.util;
const log = services.log;

function transformBuilding(buildingData: Realty.ApiResponse, options?: any) {
  if (buildingData.item) {
    const building: Realty.ApiBuilding = buildingData.item;
    const retObject: any = util.pick(building, [
      'industryGroup',
      'buildingStatus',
      'energySourceType',
      'heatingType',
      'dischargeType',
      'waterSupplyType',
      'builtUpArea',
      'totalAreaOfPrimarySpace',
      'areaOfSecondarySpace',
      'totalFloorSpace',
      'hasElevator',
      'numberOfUnits',
      'numberOfFloors',
      'typeOfBuilding',
      'links',
      'originType'
    ]);

    if (building.ident) {
      retObject.buildingNumber = building.ident.buildingNumber;
    }

    if (building.buildingStatusHistory) {
      for (let i = 0; i < building.buildingStatusHistory.length; i++) {
        const buildingStatusHistory = building.buildingStatusHistory[i];
        if (!buildingStatusHistory.buildingStatusDate || !buildingStatusHistory.buildingStatus) {
          continue;
        }

        try {
          switch (buildingStatusHistory.buildingStatus.code) {
            case ('RA'):
              retObject.buildingPermit = buildingStatusHistory.buildingStatusDate.ddmmyyyy;
              break;
            case ('IG'):
              retObject.approvedStartPermit = buildingStatusHistory.buildingStatusDate.ddmmyyyy;
              break;
            case ('FA'):
              retObject.certificateOfCompletion = buildingStatusHistory.buildingStatusDate.ddmmyyyy;
              break;
            case ('MB'):
              retObject.provisionalPermissionToUse = buildingStatusHistory.buildingStatusDate.ddmmyyyy;
              break;
            case ('TB'):
              retObject.approvedUsedFrom = buildingStatusHistory.buildingStatusDate.ddmmyyyy;
              break;
            default:
              break;
          }
        } catch (error) {
          log.warn('Error in buildings transformer -> buildingStatusHistoryLoop');
        }
      }
    }

    if (options && options.unit) {
      retObject.units = [options.unit];
    } else {
      retObject.units = [];
    }

    retObject.coordinates = building.position.geometry.coordinates;
    return retObject;
  }
}

export default transformBuilding;
